module.exports = ".db-info-block {\n  padding: 15px;\n  border: 1px solid #c42136; }\n  .db-info-block .double-booking-description {\n    padding-left: 6px; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/double-booking/events-overlapping-info/events-overlapping-info.component.scss
// module id = ./web/modern/components/common/double-booking/events-overlapping-info/events-overlapping-info.component.scss
// module chunks = 0